import React from 'react';
import { IconProps } from '.';

const SvgCircleCheckFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-1.173 12.954L7.998 11.44l-.996 1.12 3.92 3.486 6.125-6.533-1.094-1.026-5.126 5.467Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleCheckFill;
